<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useField} from 'vee-validate';
import {toTypedSchema} from "@vee-validate/zod";

const inputValue = defineModel({
  type: [String],
  required: true,
});

const props = defineProps({
  placeholder: {
    type: String,
    default: 'Type here',
  },
  buttonText: {
    type: String,
    default: 'Add',
  },
  validationSchema: {
    type: Object,
    required: false,
    default: () => null,
  },
  loading: {
    type: Boolean,
    default: false,
    required: false,
  },
});

const emit = defineEmits(['submit']);

const {
  errorMessage,
  handleReset,
  setErrors
} = useField(
  'input',
  props.validationSchema ? toTypedSchema(props.validationSchema) : null,
  {
    syncVModel: true,
});

defineExpose({
  setErrors,
})

const handleAdd = () => {
  if (!inputValue.value || errorMessage.value) {
    return;
  }

  emit('submit', inputValue.value);
  handleReset();
};

const handleBlur = () => {
  if (!inputValue.value) {
    handleReset();
  }
};
</script>

<template>
  <div class="tw-relative">
    <div class="tw-flex tw-w-full">
      <input
        v-model="inputValue"
        :placeholder="placeholder"
        class="tw-h-13 tw-border-2  tw-border-r-0 tw-flex tw-text-neutral-900 tw-self-stretch tw-rounded-l-lg tw-px-6 tw-text-lg tw-w-full"
        :class="{
          'tw-border-danger' : errorMessage,
          'focus-within:tw-border-primary tw-border-neutral' : !errorMessage,
        }"
        type="text"
        @keyup.enter="handleAdd"
        @blur="handleBlur"
      >
      <DefaultButton
        class="tw-self-stretch tw-w-[100px] tw-border tw-border-primary tw-rounded-r-lg !tw-rounded-l-none tw-text-lg tw-text-white tw-font-normal !tw-py-0"
        :disabled="errorMessage"
        :loading="loading"
        @click="handleAdd"
      >
        {{ buttonText }}
      </DefaultButton>
    </div>

    <p
      v-if="errorMessage"
      class="tw-text-sm tw-text-danger tw-left-2 tw-mt-1 tw-absolute"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>
